import { render, staticRenderFns } from "./Step3-Summary.vue?vue&type=template&id=1b32433b&scoped=true&"
import script from "./Step3-Summary.vue?vue&type=script&lang=js&"
export * from "./Step3-Summary.vue?vue&type=script&lang=js&"
import style0 from "./Step3-Summary.vue?vue&type=style&index=0&id=1b32433b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b32433b",
  null
  
)

component.options.__file = "Step3-Summary.vue"
export default component.exports